import { useEffect, useRef } from 'react'
import { ReceiptAttachmentModel } from 'src/models/receiptAttachment.models'
import { useModalRoute } from 'src/navigation/modalParams'

const RECEIPT_MODAL_NAME = 'receipt'

export interface ReceiptModalRouteState {
  isOpen: boolean
  attachment?: ReceiptAttachmentModel
  close: () => void
}

export const useReceiptModalRoute = (
  attachments: ReceiptAttachmentModel[],
  isAttachmentPopupOpen: boolean,
): ReceiptModalRouteState => {
  const modal = useModalRoute()
  const isOpen = modal.name === RECEIPT_MODAL_NAME
  const wasAttachmentPopupOpen = useRef(isAttachmentPopupOpen)
  const requestedAttachmentId = modal.params.attachmentId
  const attachment = isOpen
    ? requestedAttachmentId === undefined
      ? attachments[0]
      : attachments.find(({ id }) => id === requestedAttachmentId)
    : undefined

  useEffect(() => {
    const popupJustClosed =
      wasAttachmentPopupOpen.current && !isAttachmentPopupOpen
    wasAttachmentPopupOpen.current = isAttachmentPopupOpen

    if (isOpen && popupJustClosed) {
      modal.close()
    }
  }, [isAttachmentPopupOpen, isOpen, modal])

  return {
    isOpen,
    attachment,
    close: modal.close,
  }
}
